<template>
  <ais-state-results>
    <template v-slot="{ state, results }">
      <ul class="slo-product-filters reset">
        <li v-for="(filter, i) of filters" :key="filter.id">
          <div
            class="filter-row w-100 flex gap-md"
            :class="{ 'mt-md': i !== 0 }"
            v-show="isShown(state, results, filter.id)"
          >
            <h4
              class="filter-title flex-1 text-base fw-strong"
              v-html="getFilterLabel(filter)"
            />
            <FinishFilter
              v-if="isFinish(filter.id)"
              class="flex-1"
              :totalCount="results.nbHits"
              :filter="filter"
              :attribute="filter.id"
            />
            <TagFilter
              v-else
              class="flex-1"
              :totalCount="results.nbHits"
              :filter="filter"
              :attribute="filter.id"
            />
          </div>
          <div
            v-show="isShown(state, results, filter.id)"
            v-if="filter.id === 'variation_compliances_certifications'"
            class="compliance-message"
          >
            <p class="c-gray-800">{{ 'View a complete list of Compliances & Certifications for each product below' | t}}</p>
          </div>
        </li>
        <li class="py-md" v-if="showAdditionalFiltersToggle(state, results)">
          <ExpandButton :expanded="expanded" @click="expanded = !expanded">
            {{ 'all filters' | t }}
          </ExpandButton>
        </li>
        <!-- Enables ?variaton_sku to be passed to the URL to filter directly to variant -->
        <li class="hidden">
          <ais-refinement-list operator="and" attribute="variation_sku" />
        </li>
      </ul>
    </template>
  </ais-state-results>
</template>

<script>
import filtersConfig from '../filters-config';
import {getLangcode} from '../../main/utils';
import {transformItems} from '../../product-configurator/filters-config';
import {hasAppliedFilters} from '../utils';
import TagFilter from './TagFilter.vue';
import ExpandButton from './ExpandButton.vue';
import FinishFilter from './FinishFilter.vue';
import t from '../../main/i18n';

export default {
  components: {TagFilter, ExpandButton, FinishFilter},
  inject: ['productContext'],
  data() {
    return {
      expanded: false,
      filters: null
    };
  },
  filters: {
    t
  },
  computed: {
    productType() {
      return this.productContext ? this.productContext.productType : null;
    },
    langcode() {
      return getLangcode(this.$route.params.langcode);
    }
  },

  watch: {
    productType: {
      handler() {
        this.parseFiltersConfig();
      },
      immediate: true
    }
  },

  methods: {
    transformItems(items) {
      return transformItems(this.filters, items);
    },
    isShown(state, results, id) {
      const facet = results.facets.find(facet => facet.name === id);
      // If we don't have options to select, hide the filter
      if (!facet) return false;

      if (!this.expanded && !this.hasAppliedFilters(state)) {
        const shown = results.facets
          .filter(({name}) => this.hasOptions(state, results, name))
          .slice(0, 3)
          .map(({name}) => name);
        return shown.includes(id);
      }

      return this.hasOptions(state, results, id);
    },
    hasOptions(state, results, id) {
      // Always hide
      if (['search_api_language', 'variation_sku'].includes(id)) return false;

      const facet = results.facets.find(facet => facet.name === id);

      // If we don't have options to select, hide the filter
      if (!facet) return false;

      // If every option on the facet won't narrow the results, hide the filter
      if (Object.values(facet.data).every(count => count === results.nbHits)) {
        return this.isApplied(state, id);
      }

      return true;
    },
    hasAppliedFilters(state) {
      return hasAppliedFilters(state);
    },
    showAdditionalFiltersToggle(state, results) {
      if (this.hasAppliedFilters(state)) return false;
      return (
        results.facets.filter(({name}) => this.hasOptions(state, results, name)).length >
        3
      );
    },
    isApplied(state, id) {
      return state.facetsRefinements[id].length > 0;
    },
    getFilterLabel(filter) {
      return filter.label[this.langcode];
    },
    parseFiltersConfig() {
      const {variation} = filtersConfig[this.productType];
      this.filters = variation.map(filter => {
        filter.visible = true;
        return filter;
      });
    },
    isFinish(id) {
      return /variation_finish/.test(id);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../scss/system';

.filter-row {
  min-height: 40px;
}

.filter-title {
  max-width: 230px;
  white-space: nowrap;
  height: 40px;
  display: flex;
  align-items: center;
}

.compliance-message {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 16px;
  margin-top: 16px;

  @media (min-width: 1024px) {
    grid-template-columns: 230px 1fr;

    p {
      grid-column: 2 / 3;
    }
  }
}
</style>
